import * as React from 'react';

export default function InvalidInputHelp({ message, type }) {
  if (!message) {
    return <></>;
  }
  return message && <div className="invalid-feedback">{message}</div>;
}
